<input
  type="file"
  (change)="onUpload($event)"
  #uploadInput>
<button class="upload-file" type="button" (click)="uploadInput.click()">
  <ng-container *ngIf="!isUploading">Upload {{ fileType }}</ng-container>
  <ng-container *ngIf="isUploading">Uploading... <nz-spin nzSimple nzSize="small"></nz-spin></ng-container>
</button>
